import React from "react";
import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Spinner from "@cloudscape-design/components/spinner";
import FormField from "@cloudscape-design/components/form-field";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { tgBotsAddModalStore } from "../stores/tgBotsAddModal";

class TgBotsAddModal extends React.Component {
	resetModal = () => {
		this.props.setTgBotsAddModal({
			...this.props.tgBotsAddModal,
			show: false,
			loaded: true,
			bot_link: "",
			priority: "",
			token: "",
		});
	};

	addTgBot = () => {
		const { tgBotsAddModal } = this.props;
		const botLink = tgBotsAddModal.bot_link.trim();
		const token = tgBotsAddModal.token.trim();
		const priority = Number(tgBotsAddModal.priority);

		if (!botLink) {
			this.props.Interface.addNoty("Error", "Bot link is required");
			return;
		}

		if (tgBotsAddModal.priority === "" || Number.isNaN(priority)) {
			this.props.Interface.addNoty("Error", "Priority is required");
			return;
		}

		if (!token) {
			this.props.Interface.addNoty("Error", "Token is required");
			return;
		}

		this.props.setTgBotsAddModal({ ...tgBotsAddModal, loaded: false });
		this.props.Interface.request("set", { class: "data", module: "telegramBots", method: "add" }, { bot_link: botLink, priority, token })
			.then(() => {
				this.props.Interface.addNoty("Success", "Telegram bot was successfully added");
				this.resetModal();
				this.props.Interface.loadTgBotsList();
				this.props.Interface.loadTgBotsRotation();
			})
			.catch((error) => {
				this.props.Interface.addNoty("Error", error?.text || error?.toString?.() || "Request failed");
				this.props.setTgBotsAddModal({ ...tgBotsAddModal, loaded: true });
			});
	};

	render() {
		const { tgBotsAddModal } = this.props;

		return (
			<Modal
				visible={tgBotsAddModal.show}
				onDismiss={this.resetModal}
				header="Add Telegram bot"
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="xs">
							<Button variant="normal" onClick={this.resetModal}>
								Close
							</Button>
							<Button variant="primary" onClick={this.addTgBot} loading={!tgBotsAddModal.loaded}>
								Save
							</Button>
						</SpaceBetween>
					</Box>
				}
			>
				{tgBotsAddModal.loaded ? (
					<SpaceBetween direction="vertical" size="m">
						<FormField label="Bot link" stretch>
							<Input
								autoFocus
								inputMode="url"
								autoComplete="off"
								placeholder="Enter bot link"
								value={tgBotsAddModal.bot_link}
								onChange={({ detail }) => this.props.setTgBotsAddModal({ ...tgBotsAddModal, bot_link: detail.value })}
							/>
						</FormField>
						<FormField label="Priority" stretch>
							<Input
								type="number"
								placeholder="Enter priority"
								value={tgBotsAddModal.priority}
								onChange={({ detail }) => this.props.setTgBotsAddModal({ ...tgBotsAddModal, priority: detail.value })}
							/>
						</FormField>
						<FormField label="Token" stretch>
							<Input
								autoComplete="off"
								placeholder="Enter token"
								value={tgBotsAddModal.token}
								onChange={({ detail }) => this.props.setTgBotsAddModal({ ...tgBotsAddModal, token: detail.value })}
							/>
						</FormField>
					</SpaceBetween>
				) : (
					<Box textAlign="center">
						<Spinner size="large" />
					</Box>
				)}
			</Modal>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const tgBotsAddModal = useRecoilValue(tgBotsAddModalStore);
		const setTgBotsAddModal = useSetRecoilState(tgBotsAddModalStore);

		return <Component {...props} tgBotsAddModal={tgBotsAddModal} setTgBotsAddModal={setTgBotsAddModal} />;
	};
}

export default withRecoil(TgBotsAddModal);
